<template>
  <div class="page">test</div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    window.scrollTo(0, 0)
    next()
  }
}
</script>

<style lang="scss" scoped>

</style>
